module.exports = __webpack_public_path__ + "img/pattern01_sm_dark.c9ec87cf.jpg";